import {
  FormControl,
  MenuItem,
  Select,
} from "@mui/material";
import i18n from "i18next";
import { useState } from "react";
import { languages } from "../../languages/i18n";
import { indigo } from "@mui/material/colors";
import { setCookie, getCookie } from '../../utils/cookie';

const LanguageSelect = () => {
  const [language, setLanguage] = useState(
    getCookie("i18nextLng") ?? "de"
  );

  const handleLanguageChange = (event) => {
    const newLanguage = event.target.value;
    setLanguage(newLanguage);
    setCookie("i18nextLng", event.target.value);
    i18n.changeLanguage(newLanguage);
  };

  return (
    <FormControl size="small">
      <Select
        value={language}
        onChange={handleLanguageChange}
        sx={{
          color: indigo[50],
          ".MuiOutlinedInput-notchedOutline": {
            borderColor: indigo[50],
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: indigo[50],
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: indigo[50],
          },
          ".MuiSvgIcon-root ": {
            fill: indigo[50],
          },
        }}
      >
        {languages.map((lang) => (
          <MenuItem key={lang.code} value={lang.code}>
            {lang.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default LanguageSelect;
